import { SelectedProductCategory } from 'store/GeneralState/GeneralState.reducer'

export const hasSelectedProduct = (selectedProductCategories: SelectedProductCategory[]): boolean =>
    selectedProductCategories.some((category) => category.selectedProduct != null)
